const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');

class Scratch3GistStorage {
    constructor(runtime) {
        this.runtime = runtime;
        this._token = '';
        this._username = '';
        this._lastGistId = '';
        this._lastGistUrl = '';
        this._lastError = '';
        this._projectList = [];
    }

    getInfo() {
        return {
            id: 'gistStorage',
            name: '☁️ クラウド保存',
            color1: '#24292e',
            color2: '#1a1e22',
            blocks: [
                {
                    opcode: 'setToken',
                    blockType: BlockType.COMMAND,
                    text: 'GitHubトークンを [TOKEN] にセット',
                    arguments: {
                        TOKEN: {
                            type: ArgumentType.STRING,
                            defaultValue: ''
                        }
                    }
                },
                {
                    opcode: 'isLoggedIn',
                    blockType: BlockType.BOOLEAN,
                    text: 'ログインしている？'
                },
                {
                    opcode: 'getUsername',
                    blockType: BlockType.REPORTER,
                    text: 'ユーザー名'
                },
                '---',
                {
                    opcode: 'saveProject',
                    blockType: BlockType.COMMAND,
                    text: 'プロジェクトを [NAME] として保存 [PUBLIC]',
                    arguments: {
                        NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'My Project'
                        },
                        PUBLIC: {
                            type: ArgumentType.STRING,
                            menu: 'publicMenu',
                            defaultValue: 'public'
                        }
                    }
                },
                {
                    opcode: 'loadProject',
                    blockType: BlockType.COMMAND,
                    text: 'プロジェクト [ID] を読み込む',
                    arguments: {
                        ID: {
                            type: ArgumentType.STRING,
                            defaultValue: ''
                        }
                    }
                },
                {
                    opcode: 'deleteProject',
                    blockType: BlockType.COMMAND,
                    text: 'プロジェクト [ID] を削除',
                    arguments: {
                        ID: {
                            type: ArgumentType.STRING,
                            defaultValue: ''
                        }
                    }
                },
                '---',
                {
                    opcode: 'getLastGistId',
                    blockType: BlockType.REPORTER,
                    text: '最後のプロジェクトID'
                },
                {
                    opcode: 'getLastGistUrl',
                    blockType: BlockType.REPORTER,
                    text: '最後のプロジェクトURL'
                },
                {
                    opcode: 'getLastError',
                    blockType: BlockType.REPORTER,
                    text: '最後のエラー'
                },
                '---',
                {
                    opcode: 'getMyProjects',
                    blockType: BlockType.COMMAND,
                    text: '自分のプロジェクト一覧を取得'
                },
                {
                    opcode: 'getProjectCount',
                    blockType: BlockType.REPORTER,
                    text: 'プロジェクト数'
                },
                {
                    opcode: 'getProjectIdAt',
                    blockType: BlockType.REPORTER,
                    text: '[N] 番目のプロジェクトID',
                    arguments: {
                        N: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        }
                    }
                },
                {
                    opcode: 'getProjectNameAt',
                    blockType: BlockType.REPORTER,
                    text: '[N] 番目のプロジェクト名',
                    arguments: {
                        N: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        }
                    }
                }
            ],
            menus: {
                publicMenu: {
                    items: ['public', 'private']
                }
            }
        };
    }

    setToken(args) {
        var self = this;
        this._token = Cast.toString(args.TOKEN);
        this._lastError = '';
        
        if (this._token) {
            fetch('https://api.github.com/user', {
                headers: {
                    'Authorization': 'token ' + this._token,
                    'Accept': 'application/vnd.github.v3+json'
                }
            })
            .then(function(response) { return response.json(); })
            .then(function(data) {
                if (data.login) {
                    self._username = data.login;
                } else {
                    self._lastError = 'Invalid token';
                    self._username = '';
                }
            })
            .catch(function(error) {
                self._lastError = error.message;
                self._username = '';
            });
        }
    }

    isLoggedIn() {
        return this._token !== '' && this._username !== '';
    }

    getUsername() {
        return this._username;
    }

    saveProject(args) {
        var self = this;
        if (!this._token) {
            this._lastError = 'Token not set';
            return;
        }

        var projectName = Cast.toString(args.NAME);
        var isPublic = args.PUBLIC === 'public';

        var projectData = JSON.stringify({
            name: projectName,
            timestamp: Date.now(),
            message: 'Saved from Scratch MOD'
        });

        var gistData = {
            description: 'Scratch MOD Project: ' + projectName,
            public: isPublic,
            files: {
                'project.json': {
                    content: projectData
                },
                'info.json': {
                    content: JSON.stringify({
                        name: projectName,
                        created: new Date().toISOString(),
                        type: 'scratch-mod-project'
                    })
                }
            }
        };

        return fetch('https://api.github.com/gists', {
            method: 'POST',
            headers: {
                'Authorization': 'token ' + this._token,
                'Accept': 'application/vnd.github.v3+json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(gistData)
        })
        .then(function(response) { return response.json(); })
        .then(function(data) {
            if (data.id) {
                self._lastGistId = data.id;
                self._lastGistUrl = data.html_url;
                self._lastError = '';
            } else {
                self._lastError = data.message || 'Unknown error';
            }
        })
        .catch(function(error) {
            self._lastError = error.message;
        });
    }

    loadProject(args) {
        var self = this;
        if (!this._token) {
            this._lastError = 'Token not set';
            return;
        }

        var gistId = Cast.toString(args.ID);

        return fetch('https://api.github.com/gists/' + gistId, {
            headers: {
                'Authorization': 'token ' + this._token,
                'Accept': 'application/vnd.github.v3+json'
            }
        })
        .then(function(response) { return response.json(); })
        .then(function(data) {
            if (data.files && data.files['project.json']) {
                self._lastError = '';
            } else {
                self._lastError = 'Invalid project data';
            }
        })
        .catch(function(error) {
            self._lastError = error.message;
        });
    }

    deleteProject(args) {
        var self = this;
        if (!this._token) {
            this._lastError = 'Token not set';
            return;
        }

        var gistId = Cast.toString(args.ID);

        return fetch('https://api.github.com/gists/' + gistId, {
            method: 'DELETE',
            headers: {
                'Authorization': 'token ' + this._token,
                'Accept': 'application/vnd.github.v3+json'
            }
        })
        .then(function(response) {
            if (response.status === 204) {
                self._lastError = '';
            } else {
                self._lastError = 'Failed to delete';
            }
        })
        .catch(function(error) {
            self._lastError = error.message;
        });
    }

    getLastGistId() {
        return this._lastGistId;
    }

    getLastGistUrl() {
        return this._lastGistUrl;
    }

    getLastError() {
        return this._lastError;
    }

    getMyProjects() {
        var self = this;
        if (!this._token) {
            this._lastError = 'Token not set';
            return;
        }

        return fetch('https://api.github.com/gists', {
            headers: {
                'Authorization': 'token ' + this._token,
                'Accept': 'application/vnd.github.v3+json'
            }
        })
        .then(function(response) { return response.json(); })
        .then(function(data) {
            if (Array.isArray(data)) {
                self._projectList = data.filter(function(gist) {
                    return gist.description && gist.description.indexOf('Scratch MOD Project') !== -1;
                }).map(function(gist) {
                    return {
                        id: gist.id,
                        name: gist.description.replace('Scratch MOD Project: ', ''),
                        url: gist.html_url,
                        created: gist.created_at
                    };
                });
                self._lastError = '';
            } else {
                self._lastError = data.message || 'Unknown error';
                self._projectList = [];
            }
        })
        .catch(function(error) {
            self._lastError = error.message;
            self._projectList = [];
        });
    }

    getProjectCount() {
        return this._projectList.length;
    }

    getProjectIdAt(args) {
        var index = Cast.toNumber(args.N) - 1;
        if (index >= 0 && index < this._projectList.length) {
            return this._projectList[index].id;
        }
        return '';
    }

    getProjectNameAt(args) {
        var index = Cast.toNumber(args.N) - 1;
        if (index >= 0 && index < this._projectList.length) {
            return this._projectList[index].name;
        }
        return '';
    }
}

module.exports = Scratch3GistStorage;
